"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.array.from.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.values.js");
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.entries.js");
var _mttPostal = _interopRequireDefault(require("@gaming/mtt-postal"));
require("./postal-utils");
var _packingSlips = require("./packingSlips");
var _state = require("./state");
var _handlers = require("./handlers");
var _filters = _interopRequireWildcard(require("./filters"));
var _FederationClient = _interopRequireDefault(require("./FederationClient"));
var _queue = _interopRequireDefault(require("./queue"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
(0, _queue.default)(_mttPostal.default);
var fedx = _mttPostal.default.fedx = {
  FederationClient: _FederationClient.default,
  packingSlips: _packingSlips.packingSlips,
  handlers: _handlers.handlers,
  clients: _state.state._clients,
  transports: _state.state._transports,
  filters: _filters.default,
  addFilter: _filters.addFilter,
  removeFilter: _filters.removeFilter,
  canSendRemote: function canSendRemote(channel, topic) {
    return (0, _filters.matchesFilter)(channel, topic, "out");
  },
  configure: _state.configure,
  getPackingSlip: _packingSlips.getPackingSlip,
  onFederatedMsg: _handlers.onFederatedMsg,
  sendMessage: function sendMessage(envelope) {
    if (!_state.state._ready) {
      _state.state._outboundQueue.push(arguments);
      return;
    }
    Object.values(this.transports).forEach(function (transport) {
      transport.sendMessage(envelope);
    });
  },
  disconnect: _state.disconnect,
  _getTransports: function _getTransports() {
    return Object.keys(this.transports).reduce(function (memo, name) {
      memo[name] = true;
      return memo;
    }, {});
  },
  /*
  	signalReady( callback );
  	signalReady( "transportName" );
  	signalReady( "transportName", callback );
  	signalReady( "transportName", targetInstance, callback ); <-- this is NEW
  	signalReady( { transportNameA: targetsForA, transportNameB: targetsForB, transportC: true }, callback);
  */
  signalReady: function signalReady(transport, target, callback) {
    var _this = this;
    if (!_state.state._ready) {
      _state.state._signalQueue.push(arguments);
      return;
    }
    var transports = this._getTransports();
    switch (arguments.length) {
      case 1:
        if (typeof transport === "function") {
          callback = transport;
        } else if (typeof transport === "string") {
          transports = {};
          transports[transport] = this.transports[transport];
          callback = _state.NO_OP;
        }
        break;
      case 2:
        if (typeof transport === "string") {
          transports = {};
          transports[transport] = this.transports[transport];
        } else {
          transports = transport;
        }
        callback = target || _state.NO_OP;
        break;
      case 3:
        transports = {};
        transports[transport] = [target];
        break;
    }
    Object.entries(transports).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        name = _ref2[0],
        targets = _ref2[1];
      targets = typeof targets === "boolean" ? [] : targets;
      _this.transports[name].signalReady(targets, callback);
    });
  }
};
var _default = fedx;
exports.default = _default;
function processSignalQ(args) {
  fedx.signalReady.apply(this, args);
}
function processOutboundQ(args) {
  fedx.send.apply(this, args);
}
function processInboundQ(msg) {
  fedx.onFederatedMsg.call(this, msg);
}
_mttPostal.default.addWireTap(function (data, envelope) {
  if (fedx.canSendRemote(envelope.channel, envelope.topic)) {
    fedx.sendMessage(envelope);
  }
});
_mttPostal.default.subscribe({
  channel: _mttPostal.default.configuration.SYSTEM_CHANNEL,
  topic: "instanceId.changed",
  callback: function callback() {
    _state.state._ready = true;
    while (_state.state._signalQueue.length) {
      processSignalQ(_state.state._signalQueue.shift());
    }
    while (_state.state._outboundQueue.length) {
      processOutboundQ(_state.state._outboundQueue.shift());
    }
    while (_state.state._inboundQueue.length) {
      processInboundQ(_state.state._inboundQueue.shift());
    }
  }
});
if (_mttPostal.default.instanceId() !== undefined) {
  _state.state._ready = true;
}